import React from "react";

const PartnershipCasino = () => {
  const galleryItems = [
    "/local-assets/idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/918kiss_menu.webp",
    "/local-assets/idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/yggdrasil_menu.webp",
    "/local-assets/idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/wazdan_menu.webp",
    "/local-assets/idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/spinix_menu.webp",
    "/local-assets/idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/spade_menu.webp",
    "/local-assets/idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/simpleplay_menu.webp",
    "/local-assets/idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/sboslot_menu.webp",
    "/local-assets/idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/rsg_menu.webp",
    "/local-assets/idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/relaxgaming_menu.webp",
    "/local-assets/idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/pragmaticplay_menu.webp",
    "/local-assets/idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/popok_menu.webp",
    "/local-assets/idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/playstar_menu.webp",
    "/local-assets/idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/pgslot_menu.webp",
    "/local-assets/idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/pegasus_menu.webp",
    "/local-assets/idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/nolimit_menu.webp",
    "/local-assets/idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/netent_menu.webp",
    "/local-assets/idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/naga_menu.webp",
    "/local-assets/idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/microgaming_menu.webp",
    "/local-assets/idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/mannaplay_menu.webp",
    "/local-assets/idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/mancala_menu.webp",
    "https://idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/live22_menu.webp",
    "https://idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/kingmakers_menu.webp",
    "https://idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/kagaming_menu.webp",
    "https://idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/joker_menu.webp",
    "https://idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/jili_menu.webp",
    "https://idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/gamatron_menu.webp",
    "https://idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/funkygame_menu.webp",
    "https://idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/evoplay_menu.webp",
    "https://idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/endorphina_menu.webp",
    "https://idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/digi_menu.webp",
    "https://idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/cq9_menu.webp",
    "https://idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/booongo_menu.webp",
    "https://idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/blueprint_menu.webp",
    "https://idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/bigpot_menu.webp",
    "https://idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/betsoft_menu.webp",
    "https://idea-bet.live/theme/vagabets/wp-content/uploads/2023/09/ambslot_menu.webp",
  ];

  return (
    <div style={{  padding: "20px", color: "#fff" }}>
     <div className="elementor-widget-container">   PARTNERSHIP CASINO	</div>
      <div
        style={{
          display: "grid",
          marginTop:"15px",
          gridTemplateColumns: "repeat(6, 1fr)", // 6 columns for each row
          gap: "10px", // Space between each image
          justifyItems: "center",
          alignItems: "center",
        }}
      >
        {galleryItems.map((item, index) => (
          <div  key={index} style={{ width: "35px", height: "35px" }}>
            <img
              src={item}
              alt={`Casino Partner ${index + 1}`}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                borderRadius: "50%", // Optional: make it circular
                backgroundColor: "#00000094", // Optional: background color
                padding: "3px",
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PartnershipCasino;
